type MicLevelMeterProps = {
  readonly level: number;
};

export const MicLevelMeter = ({ level }: MicLevelMeterProps) => (
  <div className="recording-settings-panel__mic-meter">
    <div
      className="recording-settings-panel__mic-meter-fill"
      style={{ width: `${Math.round(level * 100)}%` }}
    />
  </div>
);
